import * as types from './actionTypes';

const initialState = {
  requisitions: [],
  loading: false,
  error: null,
  success: false,
};

const recruitmentRequisitionReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Recruitment Requisitions
    case types.FETCH_RECRUITMENT_REQUISITION_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_RECRUITMENT_REQUISITION_SUCCESS:
      return { ...state, loading: false, requisitions: action.payload.data || [],success: false };

    case types.FETCH_RECRUITMENT_REQUISITION_FAILURE:
      return { ...state, loading: false, error: action.payload,success: false };

    // Save Recruitment Requisition
    case types.SAVE_RECRUITMENT_REQUISITION_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.SAVE_RECRUITMENT_REQUISITION_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_RECRUITMENT_REQUISITION_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.CHANGE_REQUISITION_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.CHANGE_REQUISITION_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.CHANGE_REQUISITION_STATUS_FAILURE:
      return { ...state, loading: false, error: action.error, success: false };

    default:
      return state;
  }
};

export default recruitmentRequisitionReducer;
